<template>
  <div class="container fixation__print">
    <div class="row">
      <div class="common__title-details">Фиксация гидроизоляции</div>
      <div class="fixation__pane">
        <div class="fixation__pane-header">
          <div class="fixation__pane-header--titles">
            <div class="title">
              <span class="title__md">Угловая</span>
              <span class="title__xs">зона С</span>
            </div>
            <div class="title">
              <span class="title__md">Парапетная</span>
              <span class="title__xs">зона D</span>
            </div>
            <div class="title">
              <span class="title__md">Центральная</span>
              <span class="title__xs">зона E</span>
            </div>
          </div>
        </div>
        <div class="fixation__pane-body">
          <div class="fixation__pane-body--item__header">
            <div class="title">Тип гидроизоляции</div>
            <div class="val">
              {{ getMaterial(sectorFromState.material.id).name }}
              {{ getMaterial(sectorFromState.material.id).thickness }}
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Ветровое давление W+(-)</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.windpresure }} кПа</span>
              <span class="val__item">{{ sectorResultFromState.side.D.windpresure }} кПа</span>
              <span class="val__item">{{ sectorResultFromState.side.E.windpresure }} кПа</span>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Рекомендуемая ширина рулона</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.waterproofing_size }} м</span>
              <span class="val__item">{{ sectorResultFromState.side.D.waterproofing_size }} м</span>
              <span class="val__item">{{ sectorResultFromState.side.E.waterproofing_size }} м</span>
            </div>
          </div>
          <div class="fixation__pane-body--item last">
            <div class="title">Площадь зон</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.square }} м²</span>
              <span class="val__item">{{ sectorResultFromState.side.D.square }} м²</span>
              <span class="val__item">{{ sectorResultFromState.side.E.square }} м²</span>
            </div>
          </div>
          <div class="fixation__pane-body--item__header">
            <div class="title">Тип балласта</div>
            <div class="val" v-if="sectorFromState.material.type === 'reinforced'">
              <b>Армированная стяжка</b>
            </div>
            <div class="val" v-else>
              <b>Гранитный щебень</b>
            </div>
          </div>
          <div class="fixation__pane-body--item">
            <div class="title">Толщина балласта</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.ballast_height }} мм</span>
              <span class="val__item">{{ sectorResultFromState.side.D.ballast_height }} мм</span>
              <span class="val__item">{{ sectorResultFromState.side.E.ballast_height }} мм</span>
            </div>
          </div>
          <div class="fixation__pane-body--item last">
            <div class="title">Объем балласта</div>
            <div class="val">
              <span class="val__item">{{ sectorResultFromState.side.C.ballast_volume }} м³</span>
              <span class="val__item">{{ sectorResultFromState.side.D.ballast_volume }} м³</span>
              <span class="val__item">{{ sectorResultFromState.side.E.ballast_volume }} м³</span>
            </div>
          </div>
          <div class="fixation__pane-body--item__header">
            <div class="title">Общий объем балласта</div>
            <div class="val"><b>{{ sectorResultFromState.ballastVolumeTotalCount }} м³</b></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';

export default {
  props: {
    sectorFromState: Object,
  },
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
  },
  computed: {
    ...mapState({
      allMaterials: state => state.materials,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorResultFromState() {
      return this.$store.getters.getSectorResult(this.sectorId);
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
